export type AppConfigType = {
  blueChefUrlRoot?: string;
  jspServerUrlRoot?: string;
};

export const appConfig: AppConfigType = {
  blueChefUrlRoot: import.meta.env.VITE_APP_BLUE_CHEF_URL,
  jspServerUrlRoot: import.meta.env.VITE_JASPER_SERVER_URL,
};
